import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ReviewDataResp } from '../interfaces/review-data';
import { ROUTES } from '../../server-route';
import { MergeFCReviewRes } from '../interfaces/merge-review';

@Injectable({
  providedIn: 'root',
})
export class ReviewDataService extends ApiService {
  public fetchupdatedData(updatedObj: any): Observable<ReviewDataResp> {
    return this.get<ReviewDataResp>(ROUTES.UPDATED_DATA, {
      params: updatedObj,
    });
  }
  public fetchSlNoMergeData(paramsObj: any): Observable<ReviewDataResp> {
    return this.get<ReviewDataResp>(ROUTES.SL_NO_MERGE_DATA, {
      params: paramsObj,
    });
  }
  public fetchSlNoMergeDataList(paramsObj: any): Observable<ReviewDataResp> {
    return this.get<ReviewDataResp>(ROUTES.SL_NO_MERGE_LIST, {
      params: paramsObj,
    });
  }
  public fetchStateCount(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.MULTI_STATE_DATA, {
      params: reqData,
    });
  }
  public fetchMergeFCData(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.MERGE_REVIEW_DATA, {
      params: reqData,
    });
  }
  public fetchDetailsBySlNo(reqData: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.DETAILS_BASED_ON_SLNO, {
        memkey: reqData,
      })
    )
  }
  public approveMergeData(id: any, reqData: any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.DA_MERGE_STATUS, {
        memKey: id,
      }),
      {
        body: reqData,
      }
    );
  }
  public fetchPendingData(id: any): Observable<any> {
    return this.get<any>(ROUTES.MERGE_PENDING_DATA, {
      params: id,
    });
  }
  public fetchMergePendingData(id: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.MERGE_REVIEW_DATA_BY_SLNO, {
        memKey: id,
      })
    );
  }
  public fetchSlNoMergePendingData(paramsObj: any): Observable<any> {
    return this.get<any>(
      ROUTES.SL_NO_MERGE_REVIEW_DATA, {
      params: paramsObj,
    }
    );
  }
  public fetchUpdateCycle(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.UPDATE_CYCLE, {
      params: reqData,
    });
  }
  public fetchPinCode(state: any, district: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.PINCODES_FOR_STATE_DISTRICT, {
        state_name: state,
        district_name: district,
      })
    );
  }
  public fetchFWNames(reqBody: any): Observable<any> {
    return this.get<any>(ROUTES.FW_NAMES_REVIEW, {
      params: reqBody,
    });
  }
  public fetchWishlistItemList(updatedObj: any): Observable<any> {
    return this.get<any>(ROUTES.FETCH_WISHLIST_ITEM, {
      params: updatedObj,
    });
  }
  public fetchUserWiseWishlistItems(reqObj: any): Observable<any> {
    return this.get<any>(ROUTES.FETCH_USER_WISHLIST_ITEM, {
      params: reqObj,
    });
  }

  public rejectFcMergeData(payload: any): Observable<any>{
    return this.post<any>(ROUTES.SL_NO_MERGE_STATUS, {
      body: payload,
    })
  }

   public fetchDANames(reqBody: any): Observable<any> {
    return this.get<any>(ROUTES.DA_NAMES_REVIEW, {
      params: reqBody,
    });
  }
}
